<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактирование продукта</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click="dialog = true">
                    Удалить
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Название в Horeca</v-subheader>
                            <v-text-field
                                ref="product_name"
                                v-model="product.name"
                                v-validate="'required|max:100'"
                                data-vv-name="name"
                                :error-messages="errors.collect('name')"
                                counter="100"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>

                        <v-flex xs6 offset-xs1>
                            <v-subheader class="pa-0">Категория в Horeca</v-subheader>
                            <v-select
                                solo
                                single-line
                                hide-selected
                                item-value="id"
                                item-text="name"
                                ref="category"
                                @input="categoryChange"
                                :items="categories"
                                v-validate="'required'"
                                class="mb-5"
                                data-vv-name="category"
                                v-model="product.category"
                                label="Выберите необходимое">
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Пусто? Добавьте категории и попробуйте снова
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex v-if="project.iiko_integration" xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Iiko id</v-subheader>
                            <v-text-field
                                ref="product_iiko_id"
                                v-model="product.iiko_id"
                                data-vv-name="iiko_id"
                                clearable
                                readonly
                                :error-messages="errors.collect('iiko_id')"
                                single-line
                                text
                                solo/>
                        </v-flex>

                        <v-flex xs6 offset-xs1>
                            <v-subheader class="pa-0">Категория в Iiko</v-subheader>
                            <v-autocomplete
                                v-model="iiko.category"
                                :items="iiko_items"
                                :disabled="iiko.isLoading"
                                :loading="iiko.isLoading"
                                :search-input.sync="iiko.categorySearch"
                                color="black"
                                @change="changeIikoCategory"
                                @click:clear="clearIikoProducts"
                                single-line
                                solo
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="id"
                                clearable
                                :placeholder="iiko.isLoading ? 'Пожалуйста подождите, список подготавливается' : 'Поиск категории по названию'"
                                return-object
                            ></v-autocomplete>

                            <template v-if="iiko.category && items && items.length">
                                <v-subheader class="mt-5 pa-0">Получение ID продукта из Iiko</v-subheader>
                                <v-autocomplete
                                    v-model="iiko.product"
                                    :items="items"
                                    :search-input.sync="iiko.search"
                                    color="black"
                                    @change="changeIikoId"
                                    class="mb-5"
                                    single-line
                                    solo
                                    hide-no-data
                                    hide-selected
                                    item-text="name"
                                    item-value="id"
                                    clearable
                                    placeholder="Поиск продукта по названию из выбранной категории"
                                    return-object
                                ></v-autocomplete>
                            </template>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Цена</v-subheader>
                            <v-text-field
                                ref="product_price"
                                v-model="product.price"
                                v-validate="'required'"
                                data-vv-name="price"
                                :error-messages="errors.collect('price')"
                                single-line
                                text
                                solo
                                required
                                suffix="so`m"/>
                        </v-flex>

                        <v-flex xs6 offset-xs1>
                            <v-subheader class="pa-0">Скидка</v-subheader>
                            <v-text-field
                                ref="product_discount"
                                v-model="product.discount"
                                single-line
                                text
                                solo
                                required
                                prefix="%"/>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex v-if="project.iiko_integration" xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-checkbox label="Товар на доставку" v-model="product.iiko_delivery_append"/>
                        </v-flex>
                    </v-layout>

                    <v-layout v-if="product.iiko_delivery_append">
                        <v-flex xs5>
                            <v-subheader class="pa-0">Iiko id упаковки</v-subheader>
                            <v-text-field
                                ref="product_iiko_id"
                                v-model="product.iiko_delivery_id"
                                data-vv-name="iiko_id"
                                clearable
                                readonly
                                :error-messages="errors.collect('iiko_delivery_id')"
                                single-line
                                text
                                solo/>

                            <v-subheader class="pa-0">Цена упаковки</v-subheader>
                            <v-text-field
                                ref="product_price"
                                v-model="product.iiko_delivery_price"
                                v-validate="'required'"
                                data-vv-name="price"
                                :error-messages="errors.collect('iiko_delivery_price')"
                                single-line
                                text
                                solo
                                required
                                suffix="so`m"/>
                        </v-flex>

                        <v-flex xs6 offset-xs1>
                            <v-subheader class="pa-0">Категория в Iiko</v-subheader>
                            <v-autocomplete
                                v-model="iiko_delivery.category"
                                :items="iiko_items"
                                :disabled="iiko_delivery.isLoading"
                                :loading="iiko_delivery.isLoading"
                                :search-input.sync="iiko_delivery.categorySearch"
                                color="black"
                                @change="changeIikoDeliveryCategory"
                                @click:clear="clearIikoDeliveryProducts"
                                single-line
                                solo
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="id"
                                clearable
                                :placeholder="iiko_delivery.isLoading ? 'Пожалуйста подождите, список подготавливается' : 'Поиск категории по названию'"
                                return-object
                            ></v-autocomplete>

                            <template v-if="iiko_delivery.category && itemsDelivery && itemsDelivery.length">
                                <v-subheader class="pa-0">Получение ID продукта из Iiko</v-subheader>
                                <v-autocomplete
                                    v-model="iiko_delivery.product"
                                    :items="itemsDelivery"
                                    :search-input.sync="iiko_delivery.search"
                                    color="black"
                                    @change="changeIikoDeliveryId"
                                    class="mt-5 mb-5"
                                    single-line
                                    solo
                                    hide-no-data
                                    hide-selected
                                    item-text="name"
                                    item-value="id"
                                    clearable
                                    placeholder="Поиск продукта по названию из выбранной категории"
                                    return-object
                                ></v-autocomplete>
                            </template>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12>
                    <v-layout>
                        <upload-img
                            :image-width="1024"
                            :image-height="1024"
                            :class="`product-img--${image.personal_key}`"
                            v-model="product.img[image.personal_key]"
                            v-for="image in product.img"
                            :key="image.personal_key - 1">
                            <div slot="activator">
                                <v-avatar size="170px" v-ripple tile v-if="image.url">
                                    <v-img :src="rootURL + image.url" aspect-ratio="1">
                                        <v-layout
                                            slot="placeholder"
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-0>
                                            <v-progress-circular indeterminate color="grey"></v-progress-circular>
                                        </v-layout>
                                    </v-img>
                                    <v-btn
                                        icon
                                        color="error"
                                        class="delete-img"
                                        v-if="image.personal_key > 0"
                                        @click.stop="showDialogForDelete(image)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </v-avatar>
                                <v-avatar size="170px" v-ripple tile v-else-if="image.imageURL">
                                    <img :src="image.imageURL" alt="Нажмите чтобы добавить картинку для продукта"/>
                                </v-avatar>
                                <v-avatar size="170px" v-ripple class="grey lighten-3" tile v-else>
                                    <img src="/static/img/media/image_blank.svg"
                                         alt="Нажмите чтобы добавить картинку для продукта"/>
                                </v-avatar>
                            </div>
                        </upload-img>
                    </v-layout>
                </v-flex>

                <v-flex xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-checkbox label="Новинка" v-model="product.new"/>
                            <v-checkbox label="Популярный" v-model="product.popular"/>
                        </v-flex>

                        <v-flex xs4>
                            <v-checkbox label="Хит" v-model="product.hit"/>
                            <v-checkbox :label="product.status ? 'Включен' : 'Отключен'" v-model="product.status"/>
                        </v-flex>

                        <v-flex xs4>
                            <v-checkbox label="Включить синхронизацию" v-model="product.enable_sync"/>
                            <v-checkbox :label="attr.key" v-for="attr in product.attrs" :key="attr.id"
                                        v-model="attr.status"/>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12>
                    <v-layout>
                        <v-flex xs2>
                            <v-subheader class="pa-0">Позиция</v-subheader>
                            <v-text-field
                                ref="product_position"
                                v-model="product.position"
                                v-validate="'required'"
                                data-vv-name="position"
                                :error-messages="errors.collect('position')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>

                        <v-spacer/>

                        <v-flex xs9>
                            <v-subheader class="pa-0">Описание</v-subheader>
                            <v-textarea
                                ref="category_description"
                                v-model="product.description"
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('description')"
                                data-vv-name="description"
                                single-line
                                text
                                solo
                                required
                                counter="255"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>

            <v-dialog v-model="dialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение удаление</h4>
                    </v-card-title>
                    <v-card-text>
                        Продукт будет удален! Вы уверены что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitDelete">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="deleteProduct">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="dialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogForImgDelete" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение удаление</h4>
                    </v-card-title>
                    <v-card-text>
                        Изображение продукта будет удален. Вы уверены?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitDelete">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="deleteImg">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="dialogForImgDelete = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
import config from '../../../../config'
import Attr from '../../../../api/attr'
import Product from '../../../../api/product'
import Category from '../../../../api/category'
import UploadImg from '../../../../components/Media/Upload'
import Loader from '../../../../components/Loader/Layout'
import {mapState} from 'vuex'

export default {
    name: 'editProduct',
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        UploadImg,
        Loader
    },
    data: () => ({
        loading: false,
        loader: false,
        project: null,
        iiko: {
            isLoading: false,
            product: null,
            category: null,
            categorySearch: '',
            search: '',
        },

        iiko_delivery: {
            isLoading: false,
            product: null,
            category: null,
            categorySearch: '',
            search: '',
        },

        product: {
            img: [],
            imgNew: [],
            name: '',
            new: true,
            hit: false,
            position: 1,
            price: null,
            discount: null,
            enable_sync: true,
            status: true,
            popular: false,
            category_id: 0,
            description: '',
            attrs: [],
            variants: []
        },
        categories: [],
        addVariant: false,
        rootURL: '',
        dialog: false,
        waitDelete: false,
        imgForDelete: {},
        dialogForImgDelete: false,
        dictionary: {
            custom: {
                name: {
                    required: 'Введите название для продукта',
                    max: 'Превышено максимальное количество символов в названии'
                },
                price: {
                    required: 'Цена не указано'
                },
                description: {
                    required: 'Описание не заполнено',
                    max: 'Превышено максимальное количество символов в описании'
                },
                position: {
                    required: 'Позиция не указана'
                }
            }
        }
    }),

    watch: {
        'iiko.categorySearch': function (val) {
            if (this.iiko_items.length) return
            this.getIikoCategoryProducts()
        },
    },

    created() {
        let user = sessionStorage.getItem('user')
        if (user) {
            let userObject = JSON.parse(user)
            if (userObject) {
                this.project = userObject.data.project
            }
        }
    },

    mounted() {
        this.rootURL = config.rootPath
        this.categories = this.getCategories()
        this.getProduct(this.$route.query.productId)
        this.$validator.localize('ru', this.dictionary)
    },

    destroyed() {
        this.iiko.product = null
        this.iiko.category = null
    },

    computed: {
        ...mapState({
            iiko_items: state => state.Product.iiko_catalogue
        }),

        items() {
            if (this.iiko.category) {
                return this.iiko.category.products
            }
            return []
        },

        itemsDelivery() {
            if (this.iiko_delivery.category) {
                return this.iiko_delivery.category.products
            }
            return []
        },
    },

    methods: {
        changeIikoId(val) {
            if (val) {
                this.product.iiko_id = val.id
                if (val.sizePrices && val.sizePrices.length) {
                    this.product.price = parseInt(val.sizePrices[0].price.currentPrice)
                }
            }
        },

        changeIikoDeliveryId(val) {
            if (val) {
                this.product.iiko_delivery_id = val.id
                if (val.sizePrices && val.sizePrices.length) {
                    this.product.iiko_delivery_price = parseInt(val.sizePrices[0].price.currentPrice)
                }
            }
        },

        changeIikoCategory(val) {
            if (val) {
                this.iiko.category = val
            }
        },

        clearIikoProducts() {
            this.iiko.category = {
                id: null,
                products: [],
            }
        },

        changeIikoDeliveryCategory(val) {
            if (val) {
                this.iiko_delivery.category = val
            }
        },

        clearIikoDeliveryProducts() {
            this.iiko_delivery.category = {
                id: null,
                products: [],
            }
        },

        getProduct(id) {
            this.loader = true
            this.addVariant = false

            Product
                .getById(id)
                .then(response => {
                    this.product = response.data.data
                    this.refreshImgAndAttrs()

                    if (this.product.variants.length) {
                        this.addVariant = true
                    }
                })
                .catch(error => new Error(error))
                .finally(() => this.loader = false)
        },

        // async getIikoProducts () {
        //     this.iiko.isLoading = true
        //     try {
        //         let { data } = await Product.getIikoProducts()
        //         this.iiko.items = data
        //     } catch (e) {
        //
        //     } finally {
        //         this.iiko.isLoading = false
        //     }
        // },

        async getIikoCategoryProducts() {
            this.iiko.isLoading = true
            this.iiko_delivery.isLoading = true

            try {
                let {data} = await Product.getIikoCategoryProducts()
                this.$store.commit('storeIikoProducts', data)
            } catch (e) {

            } finally {
                this.iiko_delivery.isLoading = false
                this.iiko.isLoading = false
            }
        },

        refreshImgAndAttrs() {
            const length = this.product.img.length
            this.product.attrs.map(item => item.status = true)

            if (length < 3) {
                let blankArr = [
                    {
                        personal_key: 0,
                        url: ''
                    },
                    {
                        personal_key: 1,
                        url: ''
                    },
                    {
                        personal_key: 2,
                        url: ''
                    }
                ]

                for (let i = 0; i < this.product.img.length; i++) {
                    let image = this.product.img[i]

                    blankArr[image.personal_key] = {
                        personal_key: image.personal_key,
                        product_id: this.$route.query.productId,
                        url: image.url
                    }
                }

                this.product.img = blankArr
            }

            Attr
                .getByCategory(this.product.category_id)
                .then(response => {
                    const attrs = response.data.data

                    attrs.map(item => {
                        const isExist = this.product.attrs.filter(attr => attr.id === item.id)

                        if (!isExist.length) {
                            this.product.attrs.push({
                                id: item.id,
                                key: item.key,
                                status: false
                            })
                        }
                    })
                })
                .catch(error => new Error(error))
        },
        sendForm() {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) return

                    this.loading = true

                    this.product.attrs.map(item => {
                        if (!item.status) {
                            item.status = false
                        }
                    })

                    Product
                        .edit(this.product)
                        .then(response => {
                            this.$store.commit('updateProduct', response.data)
                            this.$store.commit('showSnackbar', {
                                text: 'Отлично! Продукт отредактирован',
                                color: 'success'
                            })
                        })
                        .catch(error => this.$store.commit('showSnackbar', {text: error.response.data.error[Object.keys(error.response.data.error)[0]][0]}))
                        .finally(() => this.loading = false)
                })
        },
        getCategories() {
            Category
                .getAll()
                .then(response => this.categories = response.data.data)
                .catch(err => new Error(err))
        },
        categoryChange(item) {
            this.product.category_id = item
        },
        deleteProduct() {
            this.waitDelete = true

            Product
                .delete(this.product.id)
                .then(response => {
                    this.$store.commit('deleteProduct', {
                        category_id: this.product.category_id,
                        id: this.product.id
                    })
                    this.$store.commit('showSnackbar', {
                        text: response.data.data,
                        color: 'success'
                    })
                    this.$router.push({name: 'categoryRoot'})
                })
                .catch(error => new Error(error))
                .finally(() => {
                    this.waitDelete = false
                    this.dialog = false
                })
        },
        showDialogForDelete(image) {
            this.imgForDelete = image
            this.dialogForImgDelete = true
        },
        deleteImg() {
            this.waitDelete = true

            Product
                .deleteImg(this.product.id, this.imgForDelete.personal_key)
                .then(response => {
                    this.product = response.data.data
                    this.refreshImgAndAttrs()
                })
                .catch(error => new Error(error))
                .finally(() => {
                    this.waitDelete = false
                    this.dialogForImgDelete = false
                })
        }
    },

    beforeRouteLeave(to, from, next) {
        next()
    },
    beforeRouteUpdate(to, from, next) {
        this.product = this.getProduct(to.query.productId)
        next()
    }
}
</script>

<style lang="scss">.delete {
    &-img {
        position: absolute !important;
        top: 0;
        right: 0;
    }
}
</style>
